import PropTypes from "prop-types"
import { ingredientsMetadataShape } from "app/lib/shared_prop_types"
import { appletFieldShape } from "partners/components/shared/shared_prop_types"

import {
  CustomLabelInput,
  VisibilityInput,
  DefaultValueInput,
} from "./tanda_field_form_inputs"

export default function TandaFields({
  appletFields,
  canEditHiddenField,
  canEditHiddenValueField,
  errors,
  fieldsByName,
  ingredientsMetadata,
  platformComposer,
  invalidRemoteFields,
  onChange,
  onInvalidResolution,
  minimalView = false,
}) {
  return (
    <div className="composer-tanda-field-items">
      {appletFields.map((appletField, index) => {
        const field = fieldsByName[appletField.name]

        if (minimalView && !field.can_have_default) return null

        const resolveError =
          invalidRemoteFields.length && invalidRemoteFields[field.id]
        const fieldErrors = errors.select(`/${index}`)

        return (
          <div className="composer-tanda-field-item" key={field.name}>
            {minimalView ? (
              <label className="label">{field.label}</label>
            ) : (
              <CustomLabelInput
                appletField={appletField}
                field={field}
                onChange={(field, data) => onChange(index, field, data)}
                errors={fieldErrors.getAll("/custom_label")}
              />
            )}

            {!minimalView && (
              <VisibilityInput
                appletField={appletField}
                field={field}
                disabled={
                  !canEditHiddenField || !field.hideable || resolveError
                }
                onChange={(field, data) => onChange(index, field, data)}
                errors={fieldErrors.getAll("/hidden")}
              />
            )}

            {field.can_have_default && (
              <DefaultValueInput
                showLabel={!minimalView}
                appletField={appletField}
                field={field}
                resolveError={resolveError}
                ingredientsMetadata={ingredientsMetadata}
                platformComposer={platformComposer}
                onChange={(field, data) => onChange(index, field, data)}
                onInvalidResolution={onInvalidResolution}
                errors={fieldErrors.getAll("/default_value")}
                disabled={!canEditHiddenValueField && appletField.hidden}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}

TandaFields.propTypes = {
  onChange: PropTypes.func.isRequired,
  onInvalidResolution: PropTypes.func.isRequired,

  errors: PropTypes.object.isRequired,

  appletFields: PropTypes.arrayOf(appletFieldShape).isRequired,
  fieldsByName: PropTypes.object.isRequired,

  canEditHiddenField: PropTypes.bool.isRequired,
  canEditHiddenValueField: PropTypes.bool.isRequired,

  invalidRemoteFields: PropTypes.object,

  ingredientsMetadata: ingredientsMetadataShape,
  platformComposer: PropTypes.bool.isRequired,
  minimalView: PropTypes.bool,
}

TandaFields.defaultProps = {
  platformComposer: false,
}
